<template>
    <div class="dv5-multiline-slide-grid-h" :style="style">
        <slot>
            <div v-for="(card, index) in example" :key="index">{{card}}</div>
        </slot>
    </div>
</template>

<script>
    export default {
        name: "dv5-multiline-slide-grid-h",
        props: {
            cols: {
                type: Number,
                default: 4
            },
            rows: {
                type: Number,
                default: 2
            },
        },
        data: function (){
            return {
                example: [
                    'teste 1',
                    'teste 2',
                    'teste 3',
                    'teste 4',
                    'teste 5',
                    'teste 6',
                    'teste 7',
                    'teste 8',
                    'teste 9',
                    'teste 10',
                    'teste 11',
                    'teste 12',
                    'teste 13',
                    'teste 14',
                    'teste 15',
                    'teste 16',
                    'teste 17',
                    'teste 18',
                    'teste 19',
                    'teste 20',
                    'teste 21',
                    'teste 22',
                ]
            }
        },
        computed: {
            style() {
                return {
                    display: 'grid',
                    gridTemplateColumns: `repeat(${this.cols}, 1fr)`,
                    gridTemplateRows: `repeat(${this.rows}, auto)`
                }
            }
        },
        methods: {
        },
        created(){
        }

    }
</script>

<style scoped lang="scss">
    .dv5-multiline-slide-grid-h{
        justify-content: stretch;
        justify-items: stretch;
        align-items: stretch;
        align-content: stretch;
        column-gap: 0.53vw;
        row-gap: 0.53vw;
        max-width: 100%!important;
        width: 100%!important;
        min-height: 0!important;
        padding: 0 0.625rem!important;
    }
    @media (max-width: 701px) {
        .dv5-multiline-slide-grid-h {
            row-gap: 0 !important;
            column-gap: 0 !important;
            padding: 0 !important;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/office/js/components/dashboard-v5/shared/MultilineSlideGridH.vue